import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentHelperService {
  private _enrollmentSuccess = false;

  get enrollmentSuccess(): boolean {
    return this._enrollmentSuccess;
  }

  set enrollmentSuccess(value: boolean) {
    this._enrollmentSuccess = value;
  }
}
